import { Pipe, PipeTransform } from '@angular/core';
import {
  hasInvalidProduct,
  ProductSelection
} from '@features/opportunities/models/product-selection/product-selection.model';

@Pipe({
  name: 'invalidProduct'
})
export class HasInvalidProductPipe implements PipeTransform {
  transform(productSelection: ProductSelection): boolean {
    return hasInvalidProduct(productSelection);
  }
}
